import React, { useEffect, useState } from 'react';

import '../styles.css';
import moment from 'moment';
import * as Yup from 'yup';
import LoginService from '../../../pages/login/services/login.service';
import { toast } from 'react-toastify';
import Toast from '../../../shared/common/toast';
import { userStore } from '../../../store/UserStore';
import CustomerOnboardingHttp from '../../../pages/customer-onboarding/services/customer.service';
import { Button, Card, Col, Row, Form, Offcanvas } from 'react-bootstrap';
import DashboardHttp from '../services/profile.service';

interface PropsType {
  handleModal: any;
  isShow: boolean;
}

const CreateSubAccount: React.FC<PropsType> = ({ handleModal, isShow }) => {
  const [isLoading, setLoading] = React.useState(false);
  const [isCreateLoading, setCreateLoading] = React.useState(false);
  const [gstnList, setGstnList] = useState<any>([]);
  const [gstnDeatil, setGstnDeatils] = useState<any>({});
  const [gstn, setGstn] = useState<any>('');
  const [title, setTitle] = useState<any>('');
  const [accountName, setAccountName] = useState<any>('');
  const [isConfirm, setConfirm] = useState<any>(false);
  const [canConfirm, setCanConfirm] = useState<any>(false);
  const [companyDetails, setCompanyDetails] = useState({
    address1: '',
    pinCode: '',
    city: '',
    state: '',
  });
  const [user, customer, setUser, setCustomer, customerId] = userStore(
    (state: any) => [
      state.user,
      state.customer,
      state.setUser,
      state.setCustomer,
      state.customerId,
    ]
  );

  useEffect(() => {
    if (customer.customerCategory === 'REGISTERED') {
      if (customer?.companyGSTIN) setTitle('Select a GSTIN');
      else setTitle('Add new account');
      if (isShow) getGstn(customer.customerId, customer?.kyc?.pan?.value);
    } else {
      setTitle('Create new account');
    }
  }, [customer, isShow]);

  useEffect(() => {
    setConfirm(false);
  }, [isShow]);

  const getGstn = async (customerId, panNumber) => {
    try {
      const data = {
        customerId: customerId,
        pan: panNumber,
      };
      const res: any = await CustomerOnboardingHttp.getGstns(data);
      if (res.status === 200 && res.data.data) {
        if (customer.customerType !== 'IND') {
          if (res.data.data.gstins && res.data.data.gstins.length > 0) {
            const ress = res.data.data.gstins.map((d) => {
              return {
                ...d,
                account: customer.accounts.find(
                  (acc) => d.gstin === acc.kyc.gstin.value
                ),
              };
            });

            setGstnList(ress);
          }
        }
      } else {
        toast.error('Something went wrong');
      }
    } catch (e: any) {
      toast.error('Something went wrong');
    }
  };

  const getGstnDetails = async () => {
    if (!gstn) return;
    setLoading(true);
    try {
      const data = {
        customerId: customer.customerId,
        gstin: gstn,
      };
      const res: any = await CustomerOnboardingHttp.getGstnDetails(data);
      if (res.status === 200 && res.data.data) {
        setGstn('');
        setGstnDeatils(res.data.data);
        setTitle('Account Details');
        setConfirm(true);
      } else {
        toast.error('Something went wrong');
      }
      setLoading(false);
    } catch (e: any) {
      setGstn('');
      setLoading(false);
      console.log(e);
      toast.error('Something went wrong');
    }
  };

  const createSubAccount = async () => {
    if (customer?.companyGSTIN) {
      createRegisteredAccount();
    } else {
      createUnregisteredSubAccount();
    }
  };
  const createRegisteredAccount = async () => {
    setCreateLoading(true);
    try {
      const data = {
        customerId: customer.customerId,
        pinCode: gstnDeatil?.address?.pinCode,
        stateName: gstnDeatil?.address?.state,
        kyc: { gstin: { value: gstnDeatil.gstin } },
      };

      const res: any = await CustomerOnboardingHttp.createGstAccount(data);
      if (res) {
        toast.success('New account created successfuly.');
        await getProfile(customer.customerId);
        setGstnDeatils({});
        handleModal(false);
      }
      setCreateLoading(false);
    } catch (err: any) {
      console.log(err);
      setGstnDeatils({});
      toast.error(err.data.errors[0].title);
      setCreateLoading(false);
    }
  };

  const createUnregisteredSubAccount = async () => {
    setCreateLoading(true);

    try {
      const data = {
        customerId: customerId,
        pan: customer.kyc.pan.value,
        pinCode: companyDetails.pinCode,
        stateName: companyDetails.state,
        gstnData: {
          address: {
            address1: companyDetails.address1,
            city: companyDetails.city,
            pinCode: companyDetails.pinCode,
            state: companyDetails.state,
            countryCode: '+91',
          },
        },
        displayName: accountName,
      };

      const res: any = await CustomerOnboardingHttp.createNonGstAccount(data);
      if (res) {
        toast.success('New account created successfuly.');
        setCompanyDetails({
          address1: '',
          pinCode: '',
          city: '',
          state: '',
        });
        await getProfile(customer.customerId);
        handleModal(false);
      }
    } catch (err: any) {
      console.log(err);
      toast.error(err.data.errors[0].title);
    } finally {
      setCreateLoading(false);
      setAccountName('');
    }
  };

  const getProfile = async (customerId: any) => {
    try {
      const userData: any = await DashboardHttp.getProfile(customerId,user?.userId);
      if (userData.status === 200 && userData.data.data) {
        setUser(userData.data.data.user);
        setCustomer(userData.data.data.customer);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <>
      <Toast />
      <Offcanvas
        show={isShow}
        onHide={() => handleModal(false)}
        placement='end'
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {customer?.customerCategory === 'UNREGISTERED' ? (
            <div className='p-2'>
              <Row>
                <Col md={12}>
                  <Form.Group className='mb-3' controlId='upiName'>
                    <Form.Label>Account Name</Form.Label>
                    <Form.Control
                      type='text'
                      value={accountName}
                      onChange={(event) => setAccountName(event.target.value)}
                    />
                  </Form.Group>
                </Col>
                <div className='col-md-12'>
                  <Button
                    disabled={isCreateLoading}
                    className='w-100 mt-3'
                    variant='primary'
                    type='button'
                    onClick={createUnregisteredSubAccount}
                  >
                    {!isCreateLoading ? (
                      'Create'
                    ) : (
                      <div className='spinner-border text-white' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    )}
                  </Button>
                </div>
              </Row>
            </div>
          ) : (
            <div className='p-2'>
              {isConfirm ? (
                <Row>
                  {customer?.companyGSTIN && (
                    <Col md={12}>
                      <Form.Group className='mb-3' controlId='gstin'>
                        <Form.Label>GSTIN</Form.Label>
                        <Form.Control
                          type='text'
                          value={gstnDeatil.gstin}
                          disabled
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col md={12}>
                    <Form.Group className='mb-3' controlId='address'>
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type='text'
                        value={
                          customer?.companyGSTIN
                            ? gstnDeatil?.address?.address1
                            : companyDetails.address1
                        }
                        onChange={(e) => {
                          if (e.target.value.length < 50) {
                            setCompanyDetails({
                              ...companyDetails,
                              address1: e.target.value,
                            });
                          }
                        }}
                        disabled={customer?.companyGSTIN}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className='mb-3' controlId='pincode'>
                      <Form.Label>Pin Code</Form.Label>
                      <Form.Control
                        type='text'
                        value={
                          customer?.companyGSTIN
                            ? gstnDeatil?.address?.pinCode
                            : companyDetails.pinCode
                        }
                        onChange={(e) => {
                          if (e.target.value.length < 50) {
                            setCompanyDetails({
                              ...companyDetails,
                              pinCode: e.target.value,
                            });
                          }
                        }}
                        disabled={customer?.companyGSTIN}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className='mb-3' controlId='city'>
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type='text'
                        value={
                          customer?.companyGSTIN
                            ? gstnDeatil?.address?.city
                            : companyDetails.city
                        }
                        onChange={(e) => {
                          if (e.target.value.length < 50) {
                            setCompanyDetails({
                              ...companyDetails,
                              city: e.target.value,
                            });
                          }
                        }}
                        disabled={customer?.companyGSTIN}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className='mb-3' controlId='state'>
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        type='text'
                        value={
                          customer?.companyGSTIN
                            ? gstnDeatil?.address?.state
                            : companyDetails.state
                        }
                        onChange={(e) => {
                          if (e.target.value.length < 50) {
                            setCompanyDetails({
                              ...companyDetails,
                              state: e.target.value,
                            });
                          }
                        }}
                        disabled={customer?.companyGSTIN}
                      />
                    </Form.Group>
                  </Col>
                  <div className='col-md-12'>
                    <Button
                      disabled={isCreateLoading}
                      className='w-100 mt-3'
                      variant='primary'
                      type='button'
                      onClick={createSubAccount}
                    >
                      {!isCreateLoading ? (
                        'Create'
                      ) : (
                        <div
                          className='spinner-border text-white'
                          role='status'
                        >
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                      )}
                    </Button>
                  </div>
                </Row>
              ) : (
                <>
                  <div className='col-md-12'>
                    <div className='input-group' style={{ display: 'inherit' }}>
                      <ul className='list-group'>
                        {gstnList.map((gstn, idx) => (
                          <li className='list-group-item d-flex justify-content-between align-items-start'>
                            <input
                              disabled={gstn.account}
                              className='form-check-input'
                              onChange={() => setGstn(gstn.gstin)}
                              type='radio'
                              name='gstin'
                              value=''
                              aria-label='...'
                            />
                            <div className='ms-2 me-auto'>
                              <div className='fw-bold'>
                                {gstn.gstin}
                                {gstn.account ? (
                                  <span className='text-success'>
                                    - Account already exists
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <Button
                      disabled={isLoading}
                      className='w-100 mt-3'
                      variant='primary'
                      type='button'
                      onClick={getGstnDetails}
                    >
                      {!isLoading ? (
                        'Confirm'
                      ) : (
                        <div
                          className='spinner-border text-white'
                          role='status'
                        >
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                      )}
                    </Button>
                  </div>
                </>
              )}
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default React.memo(CreateSubAccount);
